<template>
  <div
    v-if="amountPages"
    class="mt-4 flex w-fit items-center gap-2 text-body-lg sm:text-body-xl"
  >
    <button
      type="button"
      class="mr-1 size-[1.375em] transition-colors"
      :aria-label="$t('aria_labels.go_to_previous_item')"
      @click="emit('scroll-to-item', activeIndex - 1)"
    >
      <IconArrowDown
        class="rotate-90 transition-opacity"
        :class="{ 'opacity-20': activeIndex === 0 }"
      />
    </button>

    <span class="whitespace-nowrap">{{ activeIndex + 1 }} | {{ amountPages }}</span>

    <button
      type="button"
      class="ml-1 size-[1.25em] transition-colors"
      :aria-label="$t('aria_labels.go_to_next_item')"
      @click="emit('scroll-to-item', activeIndex + 1)"
    >
      <IconArrowDown
        class="-rotate-90 transition-opacity"
        :class="{ 'opacity-20': activeIndex === amountPages - 1 }"
      />
    </button>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  amountPages: {
    type: Number,
    required: true,
  },
  activeIndex: {
    type: Number,
    required: true,
  },
})

const emit = defineEmits(['scroll-to-item'])
</script>
